import { ChangeEvent, useEffect, useState } from 'react';

import { ProposalService } from '../../services';
import Modal from '../Modal';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import HelperForm from '../../helpers/HelperForm';
import { useNavigate } from 'react-router-dom';

interface IProp {
  proposal: any;
  pendings: any;
}
const ProposalPending = ({ proposal, pendings }: IProp) => {
  const navigate = useNavigate();
  const [pendingsProposals, setPendingsProposals] = useState<any>(pendings);
  const [isLoad, setIsLoad] = useState<boolean>(false);
  const [erroSelect, setErroSelect] = useState<string | null>(null);

  useEffect(() => {
    if (Array.isArray(pendings)) {
      setPendingsProposals(pendings);
    }
  }, [pendings]);

  const savependings = () => {
    setIsLoad(true);
    new ProposalService().SaveProposalPendingSave({ "listpending": pendingsProposals })
      .then((response: any) => {
        if (response) {
          navigate(0)
        } else {
          setIsLoad(false);
        }
      })
      .catch((error: any) => {
        Modal.show({
          title: "Erro ao salvar pendings",
          body: Modal.getErrorMessage(error, pendingsProposals),
          showCancel: true,
          showConfirm: false,
          onCancelText: "Fechar"
        });
        setIsLoad(false);
      });
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>, p: any) => {
    setIsLoad(true);
    const { files } = e.target;

    if (p.documentTypeOptions && !p.selectedDocumentTypeOption) {
      setErroSelect("Selecione o tipo de documento antes de enviar o arquivo.");
      setIsLoad(false);
      return;
    }

    const formSend = HelperForm.transformToFormDataFile({
      lightBills: files,
      ProposalPendingId: p.id,
      selectedDocumentTypeOption: p.selectedDocumentTypeOption
    });

    if (files && files.length > 0) {
      new ProposalService().postSavePendingFile(formSend)
        .then((response: any) => {
          if (response) {
            setPendingsProposals((prev: any[]) =>
              prev.map(item =>
                item.id === p.id
                  ? { ...item, urlFile: response, documentKeySelect: p.selectedDocumentTypeOption, DocumentTypeOptions: p.documentTypeOptions }
                  : item
              )
            );
          }
          setIsLoad(false);
        })
        .catch((error: any) => {
          Modal.show({
            title: "Erro ao enviar proposta",
            body: Modal.getErrorMessage(error, formSend),
            showCancel: true,
            showConfirm: false,
            onCancelText: "Fechar"
          });
          setIsLoad(false);
        });
    } else
      setIsLoad(false);
  };
  const handleDescriptionUser = (e: any, p: any) => {
    setPendingsProposals((prev: any[]) =>
      prev.map(item =>
        item.id === p.id
          ? { ...item, descriptionResponse: e }
          : item
      )
    );
  };

  const handleDocumentTypeOptionChange = (value: string, p: any) => {
    setErroSelect(null);
    setPendingsProposals((prev: any[]) =>
      prev.map(item =>
        item.id === p.id
          ? { ...item, selectedDocumentTypeOption: value }
          : item
      )
    );
  };

  const showForm = (p: any, index: number) => {
    return (<>
      {
        p.documentType &&
        <p style={{ marginTop: 0, marginBottom: 0 }}><span style={{ color: 'red' }}>{(p?.isObligatory??false)?"* ":""}</span><b>{p.alisasTitle??p.documentType}</b></p>
      }
        <p style={{ marginTop: 4, marginBottom: 3 }}>{p.description}</p>
      {
        p.descriptionRejected &&
          <p style={{ marginTop: 0, marginBottom: 3, color: '#a90303' }}><b>Motivo da Recusa: {p.descriptionRejected}</b></p>
      }
      {
        p.documentTypeOptions &&
        <>
          <select
            className="form-control mb-2"
            value={p.selectedDocumentTypeOption ?? ''}
            onChange={(e) => handleDocumentTypeOptionChange(e.target.value, p)}
          >
            <option value="">Selecione o tipo de documento</option>
            {p.documentTypeOptions.split(';').map((option: string, optionIndex: number) => (
              <option key={`${p.id}-doc-option-${optionIndex}`} value={option}>
                {option}
              </option>
            ))}
          </select>
          {
            erroSelect && (
              <span style={{ color: 'red', fontSize: 12 }}> * {erroSelect}</span>
            )
          }
        </>
      }
      {
        (p.documentType) ?
          <>
            <input
              id={index.toString()}
              type="file"
              name={p.documentType}
              onChange={(e) => handleFileChange(e, p)}
              accept=".pdf,.jpg,.jpeg,.png"
              className={`form-control ${p.urlFile ? 'is-valid' : ''}`}
            />
            <span style={{ color: '#595959', display: 'block', fontSize: 10 }}>* Aceita apenas documentos dos tipos: .pdf, .jpg, .jpeg, .png com máximo de 5mb</span>
          </>
          :
          <input
            type="text"
            className="form-control"
            id={index.toString()}
            onChange={(e) => handleDescriptionUser(e.target.value, p)}
            placeholder={'Informe sua resposta aqui'}
            value={p.descriptionResponse} />
      }
    </>);
  }

  if ((proposal?.proposalStatus?.name ?? '') === 'Encerrado' || (pendingsProposals?.length ?? 0) <= 0)
    return (<></>);

  if (!pendingsProposals?.some((p: any) => p.status === 1 || p.status === 2 || p.status === 4))
    return (<></>);

  return (
    <div style={{ marginTop: 10 }}>
      {
        isLoad === true &&
        <LoadingSpinner text='Verificando Arquivo' />
      }
      <p style={{ marginBottom: 0 }}><b>Pendências:</b></p>
      {
        pendingsProposals?.map((p: any, index: number) => (
          <div key={`${index}-${p.id}`}>
            {
              (p.status === 1) &&
              <div style={{ background: "linear-gradient(rgb(255 157 56) 0%, rgb(251, 197, 116) 100%)", borderRadius: 20, marginBottom: 6, padding: 10 }}>
                <span style={{ float: 'right', background: '#af6505', color: '#fff', padding: 3, borderRadius: 10, fontSize: 9 }}>Aguardando</span>
                {showForm(p, index)}
              </div>
            }
            {
              (p.status === 2) &&
              <div style={{ background: "linear-gradient(rgb(47 175 24) 0%, rgb(216, 253, 190) 100%)", borderRadius: 20, marginBottom: 6, padding: 10 }}>
                <span style={{ float: 'right', color: '#fff', background: '#1c550f', padding: 3, borderRadius: 10, fontSize: 9 }}>Enviado</span>
                {
                  (p.documentType) &&
                  <p style={{ marginTop: 3, marginBottom: 1 }}><b> <i className='bx bx-check' style={{ color: '#06860dff' }}></i>{p.documentType}</b></p>
                }
                <p style={{ marginTop: 4, marginBottom: 1 }}>{p.description}</p>
                <p style={{ marginBottom: 3 }}>{p.descriptionResponse}</p>
              </div>
            }
            {
              (p.status === 4) &&
              <div style={{ background: "linear-gradient(rgb(241 43 43) 0%, rgb(239 143 143) 100%)", borderRadius: 20, marginBottom: 6, padding: 10 }}>
                <span style={{ float: 'right', background: '#5a0303ff', color: '#fff', padding: 3, borderRadius: 10, fontSize: 9 }}>Recusado - Envie Novamente</span>
                <p className="m-0">Motivo: {p.descriptionRejected}</p>
                {showForm(p, index)}
              </div>
            }
          </div>
        ))
      }
      {
        (pendingsProposals?.some((p: any) => p.status === 1 || p.status === 2 || p.status === 4)) &&
          <button type="button" onClick={savependings} className="btn btn-success w-md mt-2">
            <i className='bx bx-save'></i> Salvar Pendencias
          </button>
      }
    </div>
  );
};

export default ProposalPending;
